import {
  Faro,
  getWebInstrumentations,
  initializeFaro,
  LogLevel,
} from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import {
  buildFaroConfig,
  FARO_APP_NAME,
  FARO_COLLECT_URL,
  ObservabilityEnv,
} from './config';
import { redactSensitive } from './redact';

export const initObservability = (
  env: ObservabilityEnv = process.env as ObservabilityEnv,
): Faro | null => {
  const config = buildFaroConfig(env);
  if (!config) return null;

  try {
    return initializeFaro({
      url: FARO_COLLECT_URL,
      apiKey: config.apiKey,
      app: {
        name: FARO_APP_NAME,
        version: config.version,
        environment: config.environment,
      },
      beforeSend: redactSensitive,
      consoleInstrumentation: {
        disabledLevels: [
          LogLevel.TRACE,
          LogLevel.DEBUG,
          LogLevel.LOG,
          LogLevel.INFO,
        ],
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation({
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: config.propagationUrls,
          },
        }),
      ],
    });
  } catch {
    return null;
  }
};
